import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import {
  Typography,
  Container,
  Button,
  Box,
} from "@mui/material";
import logo from "../assets/images/DSH LOGOS.png";
import Swal from "sweetalert2";

const Header = () => {
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };


  React.useEffect(() => {
    const handleScroll = () => {
      const navbar = document.getElementById("navbar");
      if (window.scrollY > 50) {
        navbar.classList.add("navbar-scrolled");
      } else {
        navbar.classList.remove("navbar-scrolled");
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out of your account.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, logout",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");

        Swal.fire({
          title: "Logged Out",
          text: "You have been logged out successfully.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        }).then(() => {
          window.location.href = "/login";
        });
      }
    });
  };

  const isLoggedIn =
    localStorage.getItem("token") && localStorage.getItem("user");

  return (
    <Container className="header">
      <AppBar
        position="fixed"
        id="navbar"
        sx={{
          backgroundColor: "white",
          width: "100vw",
          left: 0,
          right: 0,
          top: 0,
        }}
      >
        <Toolbar>
          <Box
            sx={{
              display: "flex",
              color: "black",
              alignItems: "center",
              flexGrow: "1",
            }}
          >
            <img src={logo} alt="logo" style={{ height: "60px", marginRight:10 }} />
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", color: "#007ca0" }}
            >
              DOCTOR SERVICE AT HOME
            </Typography>
          </Box>
          <Box sx={{ display: { xs: "none", md: "flex" }, flexGrow: "1", flexWrap:'wrap' }}>
            <Button className="nav-link" href="/">
              Home
            </Button>
            <Button className="nav-link" href="/about">
              About Us
            </Button>
            <Button className="nav-link" href="/services">
              Services
            </Button>
            <Button className="nav-link" href="/doctors">
              Doctors
            </Button>
            <Button className="nav-link" href="/gallery">
              Gallery
            </Button>
            <Button className="nav-link" href="/contact">
              Contact Us
            </Button>

            {isLoggedIn ? (
              <>
                <Button className="nav-link" href="/profile">
                  Profile
                </Button>
                <Button
                  className="nav-link text-dark fw-bold"
                  onClick={handleLogout}
                >
                  Logout
                </Button>
              </>
            ) : (
              <>
                <Button className="nav-link" href="/register">
                  Register
                </Button>
                <Button className="nav-link" href="/login">
                  Login
                </Button>
              </>
            )}
          </Box>
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              justifyContent: "flex-end",
            }}
          >
            <Button
              variant="contained"
              className="appointment-btn fw-bold text-light"
              href="/department"
            >
              Appointment
            </Button>
          </Box>
          <Box>
            <IconButton
              className="menu-btn"
              color="black"
              edge="end"
              onClick={handleDrawerToggle}
              sx={{ display: { xs: "flex", md: "none" }, flexGrow: "1" }}
            >
              <MenuIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer anchor="right" open={drawerOpen} onClose={handleDrawerToggle}>
        <List sx={{ width: 250 }}>
          <ListItem button component="a" href="/">
            <ListItemText primary="Home" />
          </ListItem>
          <ListItem button component="a" href="/about">
            <ListItemText primary="About Us" />
          </ListItem>
          <ListItem button component="a" href="/services">
            <ListItemText primary="Services" />
          </ListItem>
          <ListItem button component="a" href="/doctors">
            <ListItemText primary="Doctors" />
          </ListItem>
          <ListItem button component="a" href="/gallery">
            <ListItemText primary="Gallery" />
          </ListItem>
          <ListItem button component="a" href="/contact">
            <ListItemText primary="Contact Us" />
          </ListItem>

          {isLoggedIn ? (
            <>
              <ListItem button component="a" href="/profile">
                <ListItemText primary="Profile" />
              </ListItem>
              <ListItem button component="a" onClick={handleLogout}>
                <ListItemText primary="Logout" />
              </ListItem>
            </>
          ) : (
            <>
              <ListItem button component="a" href="/register">
                <ListItemText primary="Register" />
              </ListItem>{" "}
              <ListItem button component="a" href="/login">
                <ListItemText primary="Login" />
              </ListItem>
            </>
          )}
        </List>
      </Drawer>
    </Container>
  );
};

export default Header;
